/**
 * Formatta una data in formato italiano (gg-mm-aaaa)
 * @param {string|Date} dateInput - Data in formato ISO o oggetto Date
 * @param {boolean} includeTime - Se true, include anche l'ora (hh:mm)
 * @returns {string} Data formattata in italiano
 */
export const formatDataItaliana = (dateInput, includeTime = false) => {
  if (!dateInput) return "";
  
  try {
    const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;
    
    // Verifica se la data è valida
    if (isNaN(date.getTime())) return "";
    
    const giorno = String(date.getDate()).padStart(2, '0');
    const mese = String(date.getMonth() + 1).padStart(2, '0');
    const anno = date.getFullYear();
    
    const dataFormattata = `${giorno}-${mese}-${anno}`;
    
    if (includeTime) {
      const ore = String(date.getHours()).padStart(2, '0');
      const minuti = String(date.getMinutes()).padStart(2, '0');
      return `${dataFormattata} ${ore}:${minuti}`;
    }
    
    return dataFormattata;
  } catch (error) {
    console.error('Errore formattazione data:', error);
    return "";
  }
};

/**
 * Converte una data da formato ISO (aaaa-mm-gg) a formato italiano (gg-mm-aaaa)
 * Se la data è già in formato italiano, la restituisce così com'è
 * @param {string} dateStr - Data in formato ISO o italiano
 * @returns {string} Data in formato italiano
 */
export const convertToItalianFormat = (dateStr) => {
  if (!dateStr) return '';
  
  // Se è già in formato gg-mm-aaaa (primo elemento ha 2 cifre)
  if (dateStr.includes('-') && dateStr.split('-')[0].length === 2) {
    return dateStr;
  }
  
  // Se è in formato ISO aaaa-mm-gg (primo elemento ha 4 cifre)
  if (dateStr.includes('-') && dateStr.split('-')[0].length === 4) {
    const [year, month, day] = dateStr.split('-');
    return `${day}-${month}-${year}`;
  }
  
  return dateStr;
};
